module.exports = __webpack_public_path__ + "static/img/deportes_07.0df983a2.jpeg";